import { render } from "./PicturePosition.vue?vue&type=template&id=f66d7e48"
import script from "./PicturePosition.vue?vue&type=script&lang=js"
export * from "./PicturePosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__